"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var React = _interopRequireWildcard(require("react"));

var _slateReact = require("slate-react");

var _antd = require("antd");

var _reactLoadingImage = _interopRequireDefault(require("react-loading-image"));

var _image = require("./components/image");

var _imageContainer = _interopRequireDefault(require("./components/imageContainer"));

require("react-resizable/css/styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _default(options) {
  var NodeComponent = function NodeComponent(_ref) {
    var props = _extends({}, _ref);

    return React.createElement(ImageNode, _extends({}, props, options));
  };

  return NodeComponent;
}

var ImageNode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ImageNode, _React$Component);

  function ImageNode() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImageNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImageNode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isEditing: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "edit", function (e) {
      var editor = _this.props.editor;
      e.preventDefault();
      _this.target = (0, _slateReact.getEventRange)(e, editor.state.value);

      _this.setState({
        isEditing: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hidePopover", function () {
      _this.setState({
        isEditing: false
      });
    });

    return _this;
  }

  _createClass(ImageNode, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.isEditing && !(!nextState.isEditing && this.state.isEditing)) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          node = _this$props.node,
          getSrc = _this$props.getSrc,
          getWidth = _this$props.getWidth,
          getHeight = _this$props.getHeight,
          attributes = _this$props.attributes,
          children = _this$props.children,
          editor = _this$props.editor;
      var src = getSrc(node);
      var nodeWidth = getWidth(node);
      var nodeHeight = getHeight(node);
      var that = this;
      return React.createElement("span", attributes, React.createElement(_reactLoadingImage.default, {
        src: src,
        image: function image(imgProps) {
          var ratio;
          var width = nodeWidth || imgProps.width;
          var height = nodeHeight || imgProps.height;

          if (width > height && width > 700) {
            ratio = width / 700;
          } else if (height > 500) {
            ratio = height / 500;
          }

          width = Math.round(ratio ? width / ratio : width);
          height = Math.round(ratio ? height / ratio : height);
          return React.createElement(React.Fragment, null, React.createElement(_imageContainer.default, _extends({}, that.props, {
            src: imgProps.src,
            width: width,
            height: height,
            edit: that.edit,
            hidePopover: _this2.hidePopover,
            isEditing: _this2.state.isEditing
          })));
        } // change to your customized component
        ,
        loading: function loading() {
          return React.createElement(_antd.Icon, {
            type: "loading",
            style: {
              fontSize: 24
            },
            spin: true
          });
        },
        error: function error() {
          return React.createElement(_image.Alert, null, "Image link is broken");
        }
      }), children);
    }
  }]);

  return ImageNode;
}(React.Component);